import { Award, ShieldCheck, Crown, CheckCircle2, Mail, Phone, Shield } from "lucide-react";

const BADGE_MAP = {
  email_verified: { Ic: Mail, label: "Email vérifié", color: "text-emerald-400 border-emerald-500/30 bg-emerald-500/10" },
  phone_verified: { Ic: Phone, label: "Téléphone vérifié", color: "text-emerald-400 border-emerald-500/30 bg-emerald-500/10" },
  id_verified: { Ic: ShieldCheck, label: "Identité vérifiée (Stripe)", color: "text-blue-400 border-blue-500/30 bg-blue-500/10" },
  google_verified: { Ic: CheckCircle2, label: "Google", color: "text-slate-300 border-slate-600 bg-slate-800/60" },
  admin: { Ic: Shield, label: "Admin", color: "text-[#FF6B6B] border-[#FF6B6B]/40 bg-[#FF6B6B]/10" },
  trusted: { Ic: Award, label: "Trusted (5+ missions)", color: "text-[#F59E0B] border-[#F59E0B]/40 bg-[#F59E0B]/10" },
  elite: { Ic: Crown, label: "Elite (20+ missions)", color: "text-fuchsia-300 border-fuchsia-500/40 bg-fuchsia-500/10" },
};

export default function BadgeList({ badges = [], size = "sm" }) {
  const pad = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs";
  return (
    <div className="flex flex-wrap gap-1">
      {badges.map(b => {
        const cfg = BADGE_MAP[b] || { Ic: CheckCircle2, label: b, color: "text-slate-300 border-slate-600 bg-slate-800/60" };
        const Ic = cfg.Ic;
        return (
          <span key={b} title={cfg.label} data-testid={`badge-${b}`} className={`inline-flex items-center gap-1 rounded-full border ${cfg.color} ${pad}`}>
            <Ic size={size === "sm" ? 10 : 12}/> {cfg.label}
          </span>
        );
      })}
    </div>
  );
}
